module.exports = __webpack_public_path__ + "img/header-min.df3778a9.jpg";